import { Injectable } from '@angular/core';
import {
  MaritalStatus,
  OfficialLanguages,
  Patient,
  PatientData,
  Title,
} from '../data/patients-table';
import { from, Observable, of } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable()
export class PatientService extends PatientData {
  getAllPatients(): Observable<Patient[]> {
    return of(this.patientData);
  }
  getOnePatient(patientId: string): Observable<Patient> {
    return from(this.patientData).pipe(filter((x) => x.id === patientId));
  }
  createPatient(patient: Patient): void {
    this.patientData.push(patient);
  }
  deletePatient(patientId: string): void {
    this.patientData = this.patientData.filter((x) => x.id !== patientId);
  }
  updatePatient(patient: Patient): void {
    throw new Error('Method not implemented.');
  }

  private patientData: Patient[] = [
    {
      id: '24119d4a-75db-11ea-bc55-0242ac130003',
      lastName: 'Chauke',
      title: Title.Mr,
      maritalStatus: MaritalStatus.Single,
      idNumber: '8601025495081',
      firstName: 'Calvin',
      birthDate: new Date('1986-01-02T00:00:00.000Z'),
      age: 34,
      homeLanguage: OfficialLanguages.NorthernSotho,
      numberOfDependents: 0,
      occupation: 'Call center agent',
      cellphoneNumber: '081 011 0123',
      wcaClientNo: '00001',
      gender: 'Male',
      email: 'calvin@gmail.co.za',
    },
    {
      id: '24119f7a-75db-11ea-bc55-0242ac130003',
      lastName: 'Maredi',
      title: Title.Mr,
      maritalStatus: MaritalStatus.Single,
      idNumber: '90303045826081',
      firstName: 'Nkosinathi',
      birthDate: new Date('1993-03-04T00:00:00.000Z'),
      age: 27,
      homeLanguage: OfficialLanguages.NorthernSotho,
      numberOfDependents: 1,
      occupation: 'Software Developer',
      cellphoneNumber: '081 444 5496',
      wcaClientNo: 'WC00001',
      gender: 'Male',
      email: 'nkosi@code4hire.co.za',
    },
    {
      id: '2411a074-75db-11ea-bc55-0242ac130003',
      lastName: 'Botha',
      title: Title.Mrs,
      maritalStatus: MaritalStatus.Married,
      idNumber: '8402125826081',
      firstName: 'Samantha',
      birthDate: new Date('1984-02-12T00:00:00.000Z'),
      age: 38,
      homeLanguage: OfficialLanguages.Afrikaans,
      numberOfDependents: 4,
      occupation: 'Nurse',
      cellphoneNumber: '081 484 0000',
      wcaClientNo: 'WC08801',
      gender: 'Female',
      email: 'samantha@code4hire.co.za',
    },
    {
      id: '2411a150-75db-11ea-bc55-0242ac130003',
      lastName: 'Mahlangu',
      title: Title.Miss,
      maritalStatus: MaritalStatus.Single,
      idNumber: '9602125826081',
      firstName: 'Vannesa',
      birthDate: new Date('1996-02-12T00:00:00.000Z'),
      age: 26,
      homeLanguage: OfficialLanguages.Ndebele,
      numberOfDependents: 0,
      occupation: 'Pharmacists',
      cellphoneNumber: '078 484 0000',
      wcaClientNo: 'WC0444',
      gender: 'Female',
      email: 'vannessa@code4hire.co.za',
    },
    {
      id: '2411a3bc-75db-11ea-bc55-0242ac130003',
      lastName: 'Thembekwayo',
      title: Title.Dr,
      maritalStatus: MaritalStatus.Divorced,
      idNumber: '7002125826081',
      firstName: 'Vusi',
      birthDate: new Date('1970-02-12T00:00:00.000Z'),
      age: 50,
      homeLanguage: OfficialLanguages.Xhosa,
      numberOfDependents: 2,
      occupation: 'Motivational Speaker',
      cellphoneNumber: '082 484 0000',
      wcaClientNo: 'WC0405',
      gender: 'Male',
      email: 'vusi.t@code4hire.co.za',
    },
    {
      id: '2411a4a2-75db-11ea-bc55-0242ac130003',
      lastName: 'Mandela',
      title: Title.Mr,
      maritalStatus: MaritalStatus.Married,
      idNumber: '6502125826081',
      firstName: 'Mandela',
      birthDate: new Date('1965-02-12T00:00:00.000Z'),
      age: 65,
      homeLanguage: OfficialLanguages.Zulu,
      numberOfDependents: 4,
      occupation: 'State President',
      cellphoneNumber: '082 123 0000',
      wcaClientNo: 'WC0447',
      gender: 'Male',
      email: 'nelson@code4hire.co.za',
    },
    {
      id: '2411a56a-75db-11ea-bc55-0242ac130003',
      lastName: 'Ram',
      title: Title.Miss,
      maritalStatus: MaritalStatus.Single,
      idNumber: '9002125826081',
      firstName: 'Kgothatso',
      birthDate: new Date('1990-02-12T00:00:00.000Z'),
      age: 65,
      homeLanguage: OfficialLanguages.Zulu,
      numberOfDependents: 4,
      occupation: 'State President',
      cellphoneNumber: '082 123 0000',
      wcaClientNo: 'WC0447',
      gender: 'Male',
      email: 'nelson@code4hire.co.za',
    },
    //  {
    //     id: 8,
    //     surname: 'Surname B',
    //     title: 'Mrs',
    //     maritalStatus: 'Single',
    //     IdNum: '9501025495081',
    //     names: 'Patient B',
    //     dob: '1995-01-02',
    //     age: 25,
    //     homeLanguage: 'IsiZulu',
    //     numberOfDependents: 2,
    //     occupation: 'Student',
    //     cellNumber: '0720110123',
    //     tellNumber: '0114567890',
    //     wcaClientNo: 'None',
    // },
    //   {
    //     id: 9,
    //     surname: 'Surname C',
    //     title: 'Mr',
    //     maritalStatus: 'Married',
    //     IdNum: '8001025495081',
    //     names: 'Patient C',
    //     dob: '1995-01-02',
    //     age: 25,
    //     homeLanguage: 'IsiZulu',
    //     numberOfDependents: 2,
    //     occupation: 'Student',
    //     cellNumber: '0720110123',
    //     tellNumber: '0114567890',
    //     wcaClientNo: 'None',
    // },
    //   {
    //     id: 10,
    //     surname: 'Surname D',
    //     title: 'Miss',
    //     maritalStatus: 'Single',
    //     IdNum: '9101025495081',
    //     names: 'Patient C',
    //     dob: '1991-01-02',
    //     age: 29,
    //     homeLanguage: 'IsiXhosa',
    //     numberOfDependents: 1,
    //     occupation: 'Accountant',
    //     cellNumber: '0740110003',
    //     tellNumber: '0114560000',
    //     WCAClientNo: '000002',
    // },
    //   {
    //     id: 11,
    //     surname: 'Surname E',
    //     title: 'Mrs',
    //     maritalStatus: 'Married',
    //     IdNum: '7001025495081',
    //     names: 'Patient E',
    //     dob: '1970-01-02',
    //     age: 50,
    //     homeLanguage: 'English',
    //     numberOfDependents: 5,
    //     occupation: 'Retired',
    //     cellNumber: '0720450123',
    //     tellNumber: '0114565555',
    //     wcaClientNo: '00003',
    // },
    //   {
    //     id: 12,
    //     surname: 'Surname F',
    //     title: 'Mr',
    //     maritalStatus: 'Married',
    //     IdNum: '8001025495081',
    //     names: 'Patient F',
    //     dob: '1995-01-02',
    //     age: 25,
    //     homeLanguage: 'IsiZulu',
    //     numberOfDependents: 2,
    //     occupation: 'Developer',
    //     cellNumber: '0720110123',
    //     tellNumber: '0114567890',
    //     wcaClientNo: '00009',
    // },
  ];
}
